import barcodeEn from './barcode/en.json';
import barcodeZhHant from './barcode/zh-Hant.json';
import barcodeTh from './barcode/th.json';
import barcodeVi from './barcode/vi.json';

export default {
  en: barcodeEn,
  'zh-Hant': barcodeZhHant,
  vi: barcodeVi,
  th: barcodeTh,
};
